/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** ReadAuthResponse — dark-roast DTO: AuthEmailResponseDto */
export const readAuthResponseSchema = z.object({ "authRedirectUrl": z.string().nullish(), "flowType": z.enum(["Verify", "Prompt"]).nullish() });
export type ReadAuthResponse = z.infer<typeof readAuthResponseSchema>;
